import * as rxjs from 'rxjs';

export default {
    makeSubject: () => new rxjs.Subject<any>()
}
